import React, { Suspense } from 'react'
import { ThemeProvider } from '~/core/theme'
import { CollectionMenu } from './CollectionMenu'
import { useNewForge } from './hooks/useNewForge'

export const NewShard = () => {
  const elements = useNewForge()

  return (
    <ThemeProvider resetCSS>
      {typeof window !== 'undefined' && (
        <Suspense fallback="Loading...">
          {elements && (
            <>
              {elements}
              <CollectionMenu />
            </>
          )}
        </Suspense>
      )}
    </ThemeProvider>
  )
}
